import React from "react";
import { Stack, Typography } from "@mui/material";
import { FiExternalLink } from "react-icons/fi";

const AccordionIntro = () => {
  return (
    <Stack
      sx={{
        // border: "1px solid red",
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        my: 4,
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        sx={{
          padding: "20px",
          borderRadius: "20px",
          boxShadow: "0 4px 10px rgba(0, 0, 0, 0.1)",
          backgroundColor: "white",
          cursor: "pointer",
          transition: "background-color 0.3s ease",
          "&:hover": {
            backgroundColor: "#f0fdf4", // Hover background color
          },
          width: { xl: "70%", lg: "90%", xs: "90%" },
          //   border: "1px solid red",
        }}
      >
        <Typography
          sx={{
            fontSize: {
              xl: "21px",
              lg: "21px",
              md: "20px",
              sm: "20px",
              xs: "18px",
            },
            lineHeight: {
              xl: "40px",
              lg: "40px",
              md: "40px",
              sm: "40px",
              xs: "40px",
            },
            fontWeight: 600,
            color: "rgb(34, 34, 34)",
          }}
        >
          Compare All Our Plans Here
        </Typography>
        <FiExternalLink size={20} />
      </Stack>
    </Stack>
  );
};

export default AccordionIntro;
